import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuIcon from "@mui/icons-material/Menu";
import VideocamIcon from "@mui/icons-material/Videocam";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React, { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { COLOR_PRIMARY } from "../../THEME";
import { MobileViewMenu } from "./MobileViewMenu";
import {
  hideOptions,
  pages,
  solutionOption,
  textToCreativesGeneratorSettings,
  textToVideoGenerationSettings
} from "./constants";

const Header = React.memo(() => {
  const [anchorElUser, setAnchorElUser] = useState(null);
  // const [pathCheck, setPathCheck] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(null);

  const handleOpenUserMenu = useCallback((event) => {
    setAnchorElUser(event.currentTarget);
  }, []);

  const handleCloseUserMenu = useCallback(() => {
    setAnchorElUser(null);
  }, []);
  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };

  // const handleCloseUserMenu = (e) => {
  //   setAnchorElUser(null);
  // };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const location = useLocation();

  // const toggleDrawer = () => (event) => {
  //   if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
  //     return;
  //   }
  //   setMobileMenuOpen(!mobileMenuOpen);
  // };
  const toggleDrawer = useCallback(
    () => (event) => {
      if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
        return;
      }
      setMobileMenuOpen(!mobileMenuOpen);
    },
    [mobileMenuOpen]
  );

  // useEffect(() => {
  //   setPathCheck(hideOptions.filter((item) => location.pathname.startsWith(item)).length > 0);
  // }, [pathCheck, location.pathname]);
  const pathCheck = useMemo(
    () => hideOptions.filter((item) => location.pathname.startsWith(item)).length > 0,
    [location.pathname]
  );

  return (
    // position="sticky">
    <AppBar color='default' position='static'>
      {/* {pathCheck && <AppAlert />} */}
      {/* <Container sx={{ maxWidth: 1200 }}> */}
      <Box sx={{ px: "1rem" }}>
        <Toolbar>
          <Box>
            <Box
              variant='h5'
              noWrap
              component='a'
              href='https://predis.ai/'
              sx={{
                mr: 0,
                pt: 1,
                flexGrow: 1,
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none"
              }}
            >
              <link
                rel='preload'
                as='image'
                href='https://predis.ai/free-ai-tools/predis_logo.png'
              />
              <img
                src='https://predis.ai/free-ai-tools/predis_logo.png'
                alt='Logo'
                width='120'
                height='40'
              />
            </Box>
          </Box>
          <Stack
            direction={"row"}
            sx={{ display: { sm: "flex", xs: "none" }, ml: 2 }}
            alignItems={"center"}
            spacing={2}
            width='100%'
          >
            <Box
            // sx={{
            //   flexGrow: 1,
            //   display: { xs: "none", md: "flex", justifyContent: "start", alignItems: "center" },
            // }}
            >
              <Button
                onClick={handleOpenUserMenu}
                sx={{
                  my: 2,
                  color: { COLOR_PRIMARY },
                  textTransform: "none",
                  display: "flex",
                  alignItems: "center",
                  fontSize: 15,
                  fontWeight: 300,
                  "&:hover": {
                    bgcolor: COLOR_PRIMARY,
                    color: "white"
                  }
                }}
                endIcon={<ArrowDropDownIcon />}
              >
                Use Cases
              </Button>
            </Box>
            <Menu
              sx={{ mt: "60px" }}
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right"
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right"
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <Grid container spacing={3} key={+new Date()} sx={{ width: "100vw", pb: "2rem" }}>
                <Grid item xs='3' sx={{ ml: { xs: "auto" } }}>
                  <Box sx={{ borderRight: "0.0625rem solid #9e9e9e" }}>
                    <Typography variant='h6' sx={{ mt: "1.5rem", mb: "1rem" }} color={"black"}>
                      Text To Video Generation
                    </Typography>
                    {textToVideoGenerationSettings[0].subMenu.map((item, index) => (
                      <MenuItem
                        component='a'
                        href={item.linkURL}
                        onClick={handleCloseUserMenu}
                        sx={{ maxWidth: "80%" }}
                        key={index}
                      >
                        {item.linkTitle}
                      </MenuItem>
                    ))}

                    <Typography variant='h6' sx={{ mt: "1.5rem", mb: "1rem" }} color={"black"}>
                      Smart Copy Generation
                    </Typography>
                    <MenuItem
                      component='a'
                      href='https://predis.ai/social-media-ad-copy-generator/'
                      onClick={handleCloseUserMenu}
                      sx={{ maxWidth: "80%" }}
                    >
                      Social Media Ad Copy
                    </MenuItem>
                  </Box>
                </Grid>
                <Grid item xs='3'>
                  <Box sx={{ borderRight: "0.0625rem solid #9e9e9e" }}>
                    <Typography variant='h6' sx={{ mt: "1.5rem", mb: "1rem" }} color={"black"}>
                      Text to Creatives Generator
                    </Typography>
                    {textToCreativesGeneratorSettings[0].subMenu.map((item, index) => (
                      <MenuItem
                        component='a'
                        href={item.linkURL}
                        onClick={handleCloseUserMenu}
                        sx={{ maxWidth: "80%" }}
                        key={index}
                      >
                        {item.linkTitle}
                      </MenuItem>
                    ))}
                  </Box>
                </Grid>
                <Grid item xs='3' sx={{ mr: { xs: "auto" } }}>
                  <Box>
                    <Typography variant='h6' sx={{ mt: "1.5rem", mb: "1rem" }} color={"black"}>
                      Publish and Schedule
                    </Typography>
                    <MenuItem
                      component='a'
                      href='https://predis.ai/social-media-content-scheduling-tool/'
                      onClick={handleCloseUserMenu}
                      sx={{ maxWidth: "80%" }}
                    >
                      Content Scheduler
                    </MenuItem>
                    <MenuItem
                      component='a'
                      href='https://predis.ai/use-cases/approval-flow/'
                      onClick={handleCloseUserMenu}
                      sx={{ maxWidth: "80%" }}
                    >
                      Content Approval Flow
                    </MenuItem>
                    <Typography variant='h6' sx={{ mt: "1.5rem", mb: "1rem" }} color={"black"}>
                      Competitor Analysis
                    </Typography>
                    <MenuItem
                      component='a'
                      href='https://predis.ai/social-media-competitor-analysis/'
                      onClick={handleCloseUserMenu}
                      sx={{ maxWidth: "80%" }}
                    >
                      Competitor Insights
                    </MenuItem>
                  </Box>
                </Grid>
              </Grid>
            </Menu>
            <Box>
              <Button
                onClick={handleClick}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 300,
                  "&:hover": {
                    bgcolor: COLOR_PRIMARY,
                    color: "white"
                  }
                }}
                endIcon={<ArrowDropDownIcon />}
              >
                Solutions
              </Button>
            </Box>
            <Menu
              sx={{ mt: "60px" }}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left"
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left"
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              {solutionOption.map((menu) => {
                return (
                  <MenuItem onClick={handleClose} component='a' key={menu.link} href={menu.link}>
                    {menu.icon}
                    {menu.title}
                  </MenuItem>
                );
              })}
            </Menu>
            {pages.map((page) => (
              <Button
                component='a'
                key={page.link}
                href={page.link}
                sx={{
                  my: 2,
                  color: { COLOR_PRIMARY },
                  textTransform: "capitalize",
                  display: "flex",
                  alignItems: "center",
                  fontSize: 15,
                  fontWeight: 300,
                  "&:hover": {
                    bgcolor: COLOR_PRIMARY,
                    color: "white"
                  }
                }}
              >
                {page.icon && page.icon} {page.title}
              </Button>
            ))}

            {!pathCheck && (
              <>
                <>
                  <Box sx={{ ml: "auto !important" }}>
                    <a href='https://predis.ai/live-demo/'>
                      <Button
                        startIcon={<VideocamIcon fontSize='large' />}
                        size='large'
                        sx={{ textTransform: "none" }}
                      >
                        Live Demo
                      </Button>
                    </a>
                  </Box>
                  <Box>
                    <a href='https://app.predis.ai/signup'>
                      <Button
                        variant='contained'
                        sx={{ borderRadius: "10px", textTransform: "none" }}
                      >
                        Try for Free!
                      </Button>
                    </a>
                  </Box>
                </>
                <>
                  <Box>
                    <Button
                      component='a'
                      href='https://predis.ai/pricing/'
                      sx={{
                        my: 2,
                        color: { COLOR_PRIMARY },
                        textTransform: "capitalize",
                        display: "flex",
                        alignItems: "center",
                        fontSize: 15,
                        fontWeight: 300,
                        "&:hover": {
                          bgcolor: COLOR_PRIMARY,
                          color: "white"
                        }
                      }}
                    >
                      Pricing
                    </Button>
                  </Box>
                  <Box>
                    <Button
                      component='a'
                      href='https://app.predis.ai/'
                      sx={{
                        my: 2,
                        color: { COLOR_PRIMARY },
                        textTransform: "capitalize",
                        display: "flex",
                        alignItems: "center",
                        fontSize: 15,
                        fontWeight: 300,
                        "&:hover": {
                          bgcolor: COLOR_PRIMARY,
                          color: "white"
                        }
                      }}
                    >
                      Login
                    </Button>
                  </Box>
                </>
              </>
            )}
          </Stack>
          <IconButton
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" }, justifyContent: "flex-end" }}
            size='large'
            onClick={toggleDrawer(true)}
            color='inherit'
            aria-label='Open menu'
          >
            <MenuIcon />
          </IconButton>
          <SwipeableDrawer
            anchor='right'
            open={mobileMenuOpen}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
          >
            <MobileViewMenu toggleDrawer={toggleDrawer} pathCheck={pathCheck} />
          </SwipeableDrawer>
        </Toolbar>
      </Box>
      {/* </Container> */}
    </AppBar>
  );
});
export default Header;
